import type { CategoryTreeSubjectNameData } from '@/api/gen/_model/categoryTreeSubjectNameData';

export const getCategoryName = (
  categoryTreeSubjectNameData?: CategoryTreeSubjectNameData,
) => {
  if (!categoryTreeSubjectNameData) return 'ZEP QUIZ';
  return (
    categoryTreeSubjectNameData.subSubjectName ??
    categoryTreeSubjectNameData.subjectName
  );
};
